import { CommonModule } from "@angular/common";
import { Component, ChangeDetectionStrategy, signal, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Haptics, ImpactStyle } from "@capacitor/haptics";

import { HelperModalControllerService } from "src/app/helpers/helper-modal-controller.service";

export interface QrScanResult {
  code: string;
  format?: string;
  source: 'camera' | 'manual';
}

@Component({
  selector: 'app-modal-qr-scanner',
  templateUrl: './modal-qr-scanner.component.html',
  styleUrls: ['./modal-qr-scanner.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class ModalQrScannerComponent {
  private modalService = inject(HelperModalControllerService);

  isFlashlightOn = signal<boolean>(false);
  isManualEntryOpen = signal<boolean>(false);
  manualCodeInput = signal<string>('');
  scanStatus = signal<'scanning' | 'processing' | 'success'>('scanning');

  toggleFlashlight(): void {
    this.isFlashlightOn.update(v => !v);
    try {
      void Haptics.impact({ style: ImpactStyle.Light });
    } catch {
      // Ignored in desktop browser
    }
  }

  toggleManualEntry(): void {
    this.isManualEntryOpen.update(v => !v);
  }

  dismiss(result?: QrScanResult): void {
    this.modalService.dismiss(result as any, result ? 'scanned' : 'cancelled');
  }

  submitManualCode(): void {
    const code = this.manualCodeInput().trim();
    if (!code) return;

    try {
      void Haptics.impact({ style: ImpactStyle.Medium });
    } catch {
      // Ignored
    }

    this.scanStatus.set('success');
    setTimeout(() => {
      this.dismiss({ code, source: 'manual' });
    }, 400);
  }
}
